import { render, staticRenderFns } from "./group-blank.vue?vue&type=template&id=320a3958&scoped=true&"
import script from "./group-blank.vue?vue&type=script&lang=js&"
export * from "./group-blank.vue?vue&type=script&lang=js&"
import style0 from "./group-blank.vue?vue&type=style&index=0&id=320a3958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a3958",
  null
  
)

export default component.exports